<template>
  <div>
    <p
      class="mb-0 py-4"
      v-if="showType == 'form-builder'"
      :style="properties.style"
      v-html-sanitize="$sanitize(properties.value)"
    ></p>
    <div v-if="showType == 'properties'">
      <text-v1-properties :formId="formId" />
    </div>
    <p    
      v-show="!computedHidden"
      class="mb-0"
      v-if="(showType == 'form-submitter' || showType == 'e-form') && !this.properties.hideOnEdit"
      :style="properties.style"
      v-html-sanitize="sanitizeSuperComputeFormSubmitterValue"
    ></p>
    <p
      class="mb-0"
      v-if="showType == 'form-viewer'"
      :style="properties.style"
      v-html-sanitize="sanitizeSuperComputeFormSubmitterValue"
    ></p>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import TextV1Properties from "./TextV1Properties.vue";
export default {
  name: "TextV1",
  components: { TextV1Properties },
  props: ["showType", "properties", "form", "id", "formId"],
  data() {
    return {
      computedProperties: ["value", "hidden"],
      computedConditions: {}
    };
  },
  mounted() {
    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      if(this.properties.hideOnView) {
        return "";
      }
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
      return `
      <div class="mb-0 form-group text-component" style="${this.getComponentComputedProperties(
        "style"
      )}">
        ${this.sanitizeSuperComputeFormSubmitterValue}
      </div>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    sanitizeSuperComputeFormSubmitterValue() {
      const result = this.superComputeFormSubmitterValue({
        elementId: this.id,
        property: null,
        value: this.properties.value,
        defaultValue: "",
        form: this.form
      });

      return this.$sanitize(result);
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
